import { register } from '../../../JavaScript/Utils'

export const FaqList = (el: HTMLElement) => {
  const filterButtons: NodeListOf<HTMLElement> = el.querySelectorAll('.category-filter')
  const categoryContainers: NodeListOf<HTMLElement> = el.querySelectorAll('.category-container')
  const resultsContainer: HTMLElement = el.querySelector('.results-count')

  let activeCategoryId: number

  const hideAll = () => categoryContainers.forEach(categoryContainer => categoryContainer.classList.add('d-none'))
  const showAll = () => categoryContainers.forEach(categoryContainer => categoryContainer.classList.remove('d-none'))

  const updateCount = () =>  {
    const visibleCategories: NodeListOf<HTMLElement> = el.querySelectorAll('.category-container:not(.d-none) .faq-entry')
    resultsContainer.textContent = `${visibleCategories.length}`
  }

  const changeCategory = (newCategoryId: number) => {
    if (activeCategoryId !== undefined) {
      if (activeCategoryId !== newCategoryId) {
        // Case: Change active filter to new filter and show new active category
        categoryContainers[activeCategoryId].classList.add('d-none')
        categoryContainers[newCategoryId].classList.remove('d-none')
        filterButtons[activeCategoryId].classList.remove('is--active')
        filterButtons[newCategoryId].classList.add('is--active')
        activeCategoryId = newCategoryId
      } else {
        // Case: Deactivate (active) filter and show all categories
        showAll()
        filterButtons[activeCategoryId].classList.remove('is--active')
        activeCategoryId = undefined
      }
    } else {
      // Case: Set active filter (from no filter) and show new active category
      hideAll()
      categoryContainers[newCategoryId].classList.remove('d-none')
      filterButtons[newCategoryId].classList.add('is--active')
      activeCategoryId = newCategoryId
    }

    updateCount()
  }

  filterButtons.forEach(filterButton => filterButton.addEventListener('click', (e: Event) => {
    if (e.currentTarget instanceof HTMLElement) {
      changeCategory(+e.currentTarget.dataset.categoryId)
    }
  }))

  updateCount()
}

register('FaqList', FaqList)
